import React from 'react';
import { useSelector } from 'react-redux';
import {Routes} from "../../../routes";
import {useHistory} from "react-router-dom";
import MercadoObjetivo from "../../components/Demand/MercadoObjetivo";
import Competitor from "../../components/Demand/Competitor";
//import ProductList from "../../components/Product/ProductList";
// eslint-disable-next-line react-hooks/rules-of-hooks


function CompetitorPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <Competitor ciemId={ciemId}/>
        </div>
    );
}

export default CompetitorPage;